import React from "react";
// import "../../Styles/speech-module.css";

const SpeechEmbed = ({ fileUrl, height = "100%", width = "100%" }) => {
  if (!fileUrl) return <div>No PDF provided.</div>;

  return (
    <iframe
      className="powerbi-module"
      title="Speech PDF"
      width={width}
      height={height}
      src={fileUrl}
      allowFullScreen={true}
      style={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        height: "90vh",
        padding: "2rem",
      }}
    />
  );
};

export default SpeechEmbed;
